import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { getDataOptionsFieldDefinition } from "@store/Framework/Common/Utilities/dataOptions";
import { blockMarginOptions } from "@store/Library/Components/Toolkit/Block/Block";

const blockMarginField = {
    ...getDataOptionsFieldDefinition(blockMarginOptions),
    displayName: "Spacing",
} as DropDownFieldDefinition<string>;

export default blockMarginField;
